// Shared base for the switching incidents (Trunk VLAN, EtherChannel, STP root): the Domain 02
// campus (src/domains/d02/u14-final.js — DSW1 multilayer core, ASW2 / ASW3 access, LACP
// Port-channels, 802.1Q trunks, Rapid PVST+, SVI routing) and its design checks. Nothing here
// changes the campus or the D02 missions; incidents only apply their own fault on top.
import { campus, CHECKS } from '../domains/d02/u14-final.js';

export { campus, CHECKS };
export const PO2_ASW3 = ['GigabitEthernet0/1', 'GigabitEthernet0/2'];
export const PO1_PORTS = ['GigabitEthernet0/1', 'GigabitEthernet0/2'];

/** Diagram of the campus (same positions as the D02 final), with optional extra nodes / notes. */
export function campusLayout({ title, nodes = {}, notes = {}, height = 470 } = {}) {
  return {
    width: 980, height, title,
    nodes: {
      DSW1: { x: 490, y: 70, type: 'switch', sub: 'Core · 3560 · root · SVIs .1' },
      ASW2: { x: 250, y: 250, type: 'switch', sub: 'Floor 2 · mgmt .12' },
      ASW3: { x: 730, y: 250, type: 'switch', sub: 'Floor 3 · mgmt .13' },
      SRV1: { x: 860, y: 70, type: 'server', sub: '10.10.30.10 · VLAN 30' },
      PC1: { x: 110, y: 400, type: 'pc', sub: 'Sales · VLAN 10 · .10.21' }, PC2: { x: 340, y: 400, type: 'pc', sub: 'Support · VLAN 20 · .20.21' },
      PC3: { x: 640, y: 400, type: 'pc', sub: 'Sales · VLAN 10 · .10.31' }, PC4: { x: 870, y: 400, type: 'pc', sub: 'Support · VLAN 20 · .20.31' },
      ...nodes,
    },
    zones: [{ x: 20, y: 20, w: 940, h: height - 30, label: 'CEBU CAMPUS · VLAN 10 SALES · 20 SUPPORT · 30 SERVERS · 99 MGMT (native)' }],
    linkNotes: {
      'DSW1:GigabitEthernet0/1--ASW2:GigabitEthernet0/1': 'Po1 · LACP',
      'DSW1:GigabitEthernet0/3--ASW3:GigabitEthernet0/1': 'Po2 · LACP',
      'ASW2:FastEthernet0/24--ASW3:FastEthernet0/24': 'mgmt ring · VLAN 99 only',
      ...notes,
    },
  };
}

/** The as-built design, shown in every campus incident (the learner fixes back TO this). */
export const CAMPUS_DESIGN = `<table><tr><th>Item</th><th>Design</th></tr>
<tr><td>VLANs</td><td>10 SALES · 20 SUPPORT · 30 SERVERS (DSW1 only) · 99 MGMT</td></tr>
<tr><td>Po1</td><td>DSW1 Gi0/1–2 (LACP active) ↔ ASW2 Gi0/1–2 (passive) · trunk native 99</td></tr>
<tr><td>Po2</td><td>DSW1 Gi0/3–4 (LACP active) ↔ ASW3 Gi0/1–2 (passive) · trunk native 99</td></tr>
<tr><td>Allowed</td><td>Po1 and Po2 (both ends) 10,20,30,99 · mgmt ring Fa0/24 = 99 only</td></tr>
<tr><td>Users</td><td>PC1 / PC3 Sales (VLAN 10) · PC2 / PC4 Support (VLAN 20) · SRV1 file server 10.10.30.10</td></tr>
<tr><td>STP</td><td>Rapid PVST+ · DSW1 root (24576) · ASW2 secondary (28672)</td></tr></table>`;
